(function () {
    function init() {
        var searchInput = document.getElementById('nf-search-input');
        var yearSelect = document.getElementById('nf-year');
        var monthSelect = document.getElementById('nf-month');
        var searchBtn = document.getElementById('nf-search-btn');
        var clearKeyword = document.getElementById('nf-clear-keyword');
        var clearYear = document.getElementById('nf-clear-year');
        var clearMonth = document.getElementById('nf-clear-month');
        var clearTag = document.getElementById('nf-clear-filter-tag');

        var pageUrl = window.location.pathname.replace(/\/+$/, '');

        function buildSearchParams() {
            var sentinel = document.getElementById('lazy-sentinel');
            var currentFilterId = sentinel ? (sentinel.getAttribute('data-filter-id') || '') : '';
            var newParams = new URLSearchParams();

            if (currentFilterId) newParams.set('filterId', currentFilterId);

            var keyword = searchInput ? searchInput.value.trim() : '';
            if (keyword) newParams.set('keyword', keyword);

            var year = yearSelect ? yearSelect.value : '';
            if (year) newParams.set('year', year);

            var month = monthSelect ? monthSelect.value : '';
            if (month) newParams.set('month', month);

            return newParams;
        }

        function doSearch() {
            var qs = buildSearchParams().toString();
            window.location.href = pageUrl + (qs ? '?' + qs : '');
        }

        function removeParamAndNavigate(paramName) {
            var params = new URLSearchParams(window.location.search);
            params.delete(paramName);

            if (paramName === 'filterId') {
                var sentinel = document.getElementById('lazy-sentinel');
                if (sentinel) sentinel.setAttribute('data-filter-id', '');
            }

            var qs = params.toString();
            window.location.href = pageUrl + (qs ? '?' + qs : '');
        }

        if (searchBtn) searchBtn.addEventListener('click', doSearch);
        if (searchInput) searchInput.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); doSearch(); }
        });

        if (clearKeyword) clearKeyword.addEventListener('click', function () { removeParamAndNavigate('keyword'); });
        if (clearYear) clearYear.addEventListener('click', function () { removeParamAndNavigate('year'); });
        if (clearMonth) clearMonth.addEventListener('click', function () { removeParamAndNavigate('month'); });

        if (clearTag) {
            clearTag.addEventListener('click', function (e) {
                e.preventDefault();
                var param = clearTag.getAttribute('data-clear-param') || 'filterId';
                removeParamAndNavigate(param);
            });
        }

        var sentinel = document.getElementById('lazy-sentinel');
        if (!sentinel) return;

        var pageId = parseInt(sentinel.getAttribute('data-page-id'), 10);
        if (!pageId) return;

        var filterId = sentinel.getAttribute('data-filter-id') || '';
        var batchSize = 12;
        var loaded = parseInt(sentinel.getAttribute('data-loaded'), 10) || 0;
        var loading = false;
        var hasMore = true;
        var container = document.getElementById('lazy-container');
        var viewMoreBtn = document.getElementById('view-more-btn');
        var spinner = document.getElementById('lazy-spinner');
        var endMsg = document.getElementById('lazy-end');

        if (!viewMoreBtn) return;

        (function createBackToTop() {
            if (document.getElementById('btn-back-to-top')) return;

            var btn = document.createElement('button');
            btn.className = 'btn-back-to-top';
            btn.id = 'btn-back-to-top';
            btn.setAttribute('aria-label', 'Back to top');

            var svgStr = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<polyline points="17 11 12 6 7 11"></polyline>' +
                '<polyline points="17 18 12 13 7 18"></polyline>' +
                '</svg>';

            btn.innerHTML = svgStr + '<span>Back to top</span>';
            document.body.appendChild(btn);

            function updateVisibility() {
                if (window.scrollY > 200) {
                    btn.classList.add('is-visible');
                } else {
                    btn.classList.remove('is-visible');
                }
            }

            window.addEventListener('scroll', updateVisibility, { passive: true });

            btn.addEventListener('click', function () {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            });
        })();

        var urlParams = new URLSearchParams(window.location.search);
        var searchKeyword = urlParams.get('keyword') || '';
        var searchYear = urlParams.get('year') || '';
        var searchMonth = urlParams.get('month') || '';
        var isSearchMode = !!(searchKeyword || searchYear || searchMonth);

        if (loaded < batchSize) {
            showEnd();
            return;
        }

        function makeResizedUrl(base, w, h) {
            if (!base) return '';
            return base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w + '&height=' + h;
        }

        function buildLazyImageBlock(imageUrl) {
            var ratio = '0.6666666666666666666666666667';
            var sizesAttr = '366px';
            var w1 = 120, w2 = 360, w3 = 540;
            var h1 = Math.round(w1 * 2 / 3), h2 = Math.round(w2 * 2 / 3), h3 = Math.round(w3 * 2 / 3);
            var u1 = makeResizedUrl(imageUrl, w1, h1);
            var u2 = makeResizedUrl(imageUrl, w2, h2);
            var u3 = makeResizedUrl(imageUrl, w3, h3);

            var dataSrc = u1;
            var dataSrcSet = u1 + ' ' + w1 + 'w,' + u2 + ' ' + w2 + 'w,' + u3 + ' ' + w3 + 'w';
            var srcSet = dataSrcSet;

            return '<div class="lazywrap " aspect="3:2">' +
                '<img class="lazyautosizes lazyloaded" data-src="' + dataSrc + '" data-srcset="' + dataSrcSet + '" data-ratio="' + ratio + '" sizes="' + sizesAttr + '" alt="" srcset="' + srcSet + '" src="' + dataSrc + '">' +
                '</div>';
        }

        function buildCard(item) {
            var img = '';
            if (item.hasImage && item.imageUrl) {
                img = buildLazyImageBlock(item.imageUrl);
            }

            return '<div class="item col-md-4"><article class="card">' + (img ? '<div class="card-image-wrap">' + img + '</div>' : '') +
                '<div class="card-body">' +
                '<h5 class="card-headline"><a href="' + (item.link || '#') + '">' + (item.title || '') + '</a></h5>' +
                '<small class="card-date">' + (item.shortDate || '') + '</small>' +
                '<p class="card-text">' + (item.text || '') + '</p>' +
                '</div></article></div>';
        }

        function showEnd() {
            hasMore = false;
            if (viewMoreBtn) viewMoreBtn.classList.add('d-none');
            if (endMsg) endMsg.classList.remove('d-none');
        }

        function buildUrl() {
            if (isSearchMode) {
                var url = '/webapi/articles/search?pageId=' + pageId + '&skip=' + loaded + '&pageSize=' + batchSize;
                if (filterId) url += '&filterId=' + encodeURIComponent(filterId);
                if (searchKeyword) url += '&keyword=' + encodeURIComponent(searchKeyword);
                if (searchYear) url += '&year=' + encodeURIComponent(searchYear);
                if (searchMonth) url += '&month=' + encodeURIComponent(searchMonth);
                return url;
            }

            var loadUrl = '/webapi/articles/load?pageId=' + pageId + '&skip=' + loaded + '&take=' + batchSize;
            if (filterId) loadUrl += '&filterId=' + encodeURIComponent(filterId);
            return loadUrl;
        }

        function loadMore() {
            if (loading || !hasMore) return;
            loading = true;
            viewMoreBtn.classList.add('d-none');
            if (spinner) spinner.classList.add('show');

            fetch(buildUrl())
                .then(function (r) {
                    if (!r.ok) throw new Error(r.status);
                    return r.json();
                })
                .then(function (data) {
                    var items = data.items || [];
                    if (items.length) {
                        var section = document.createElement('div');
                        section.className = 'container section-three-cards lazy-batch';
                        var html = '<div class="inner"><div class="row">';
                        items.forEach(function (item) { html += buildCard(item); });
                        html += '</div></div>';
                        section.innerHTML = html;
                        container.appendChild(section);
                        loaded += items.length;
                        requestAnimationFrame(function () { section.classList.add('visible'); });
                    }

                    loading = false;
                    if (spinner) spinner.classList.remove('show');

                    if (!data.hasMore || items.length < batchSize) {
                        showEnd();
                    } else {
                        viewMoreBtn.classList.remove('d-none');
                    }
                })
                .catch(function () {
                    loading = false;
                    if (spinner) spinner.classList.remove('show');
                    showEnd();
                });
        }

        viewMoreBtn.addEventListener('click', loadMore);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();